<template>
  <div
    class="ui-select-option-item"
    :class="classList"
    @click="clickHandler"
  >
    <slot>
      <div class="ui-select-option-item__body">
        <slot name="before" />
        <div class="ui-select-option-item__content">
          <div class="ui-select-option-item__value">
            {{ value }}
          </div>
          <div class="ui-select-option-item__subtext">
            {{ subtext }}
          </div>
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'UiSelectOptionItem',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    subtext: {
      type: [String, Number],
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'm',
      validator (size) {
        return ['s', 'm'].indexOf(size) !== -1
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classList () {
      return [
        `size-${this.size}`,
        {
          active: this.active
        }
      ]
    }
  },
  methods: {
    clickHandler () {
      if (this.disabled) return
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-select-option-item {
  @include font-16;
  display: flex;
  align-items: center;
  padding: 14px 16px;
  color: $black-02;
  background-color: $light-01;

  &.size-s {
    flex-shrink: 0;
    min-height: 40px;
    padding: 8px 16px;
  }

  &.active {
    background-color: $blue-5;
  }

  &:hover {
    color: $primary;
    background-color: $blue-5;
  }

  &__body {
    display: flex;
    column-gap: 8px;
    flex-grow: 1;
  }

  &__content {
    display: flex;
    flex-wrap: wrap;
    column-gap: 8px;
    justify-content: space-between;
    align-items: baseline;
    flex-grow: 1;
    word-break: break-word
  }

  &__subtext {
    @include font-14;
    color: $gray-3;
  }
}
</style>
